import { Divider, Hidden, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { rst } from 'rt-state';
import { TR } from '../../../../commons';
import CountUp from 'react-countup';
import { Margin } from '../../../../components/margin';
import { useInView } from 'react-intersection-observer';
import { statsQuery_byGraphQL } from '../../../../commons/graphqlClient/graphAPI';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '16px 0px 16px 0px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        //fontSize: isMobileDevice() ? '13px' : '16px',
        [theme.breakpoints.down('sm')]: {
            //padding: '28px 16px',
            width: '100%',
            // justifyContent: 'space-between',
        },
    },
    item: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // marginBottom: '30px',
        width: '100%',
        background: 'rgb(247 247 247)',
        '& img': {
            marginTop: '0px',
            [theme.breakpoints.down('sm')]: {
                width: '40%',
                margin: '0px 0px 0px 0px',
            },
        },
    },
    itemImg: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        // marginBottom: '30px',
        width: '50%',
        background: 'rgb(247 247 247)',
        '& img': {
            marginTop: '0px',
            [theme.breakpoints.down('sm')]: {
                width: '90%',
                margin: '0px 0px 0px 0px',
            },
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        //paddingLeft: '31px',
        padding: '14px 14px 0px 14px',
        //padding: '12px 12px 12px 12px',
        [theme.breakpoints.down('sm')]: {
            width: '50%',
            paddingLeft: '0px',
        },
        '& p': {
            fontSize: '20px',
            padding: '10px 0px 10px 0px',
            margin: '0px 0px 0px 0px',
            color: 'rgb(123 123 123)',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
                margin: '0px',
                fontSize: '12px',
                lineHeight: '8px',
            },
        },
        '& hr': {
            width: '20%',
            borderTop: 'solid #96D9D2 1px',
            textAlign: 'center',
        },
    },
    title: {
        fontSize: '34px',
        // color: 'rgb(123 123 123)',
        fontWeight: 'bold',
        textAlign: 'center',
        display: 'inline-block',
        padding: '10px 10px 10px 10px',
        '& h3': {
            display: 'inline-block',
            float: 'center',
            fontWeight: 'bold',
            [theme.breakpoints.down('sm')]: {
                fontSize: '20px',
                lineHeight: '26px',
                margin: '0px 0px 10px 0px',
                textAlign: 'center',
                fontWeight: 'bold',
            },
        },
        '& h4': {
            display: 'inline-block',
            fontWeight: 'normal',
            float: 'center',
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
                lineHeight: '26px',
                margin: '0px 0px 5px 0px',
            },
        },
    },
}));
export const MobileTransactionCard = rst.create((ctx) => {
    return (props) => {
        const classes = useStyles();
        const [updateTransactionData, setTransactionData] = useState('');
        const [updateNewComersData, setNewComersData] = useState('');
        useEffect(() => {
            getStatsInfo();
        }, []);

        const getStatsInfo = async () => {
            const statsInfoResult: any = await statsQuery_byGraphQL();
            setTransactionData(statsInfoResult.data.statsInfo.propertiesSoldInLast15Days);
            setNewComersData(statsInfoResult.data.statsInfo.propertiesTaggedInLast15Days);
        };
        const [ref, inView] = useInView({
            threshold: 0.3,
            triggerOnce: true,
        });

        return (
            <div style={{ background: 'rgb(255 255 255)' }}>
                <div className={classes.root}>
                    <div className={classes.item}>
                        <div className={classes.itemImg}>
                            <img src={`${process.env.PUBLIC_URL}/static/images/pc-1.png`} alt="data-ico.png" />
                        </div>
                        <div className={classes.content}>
                            <p style={{ lineHeight: 1 }}>
                                <TR name={'NewHome_LatestTransactionCardNumbers1Up'} />
                            </p>
                            <div className={classes.title} ref={ref}>
                                <h3>+</h3>
                                <CountUp
                                    start={0}
                                    end={inView ? Number(updateTransactionData) : 0}
                                    duration={2}
                                    useEasing={true}
                                />
                                {'  '}
                                <h4>
                                    <TR name={'NewHome_Data'} />
                                </h4>
                            </div>
                            <hr></hr>
                            <p style={{ lineHeight: 1 }}>
                                <TR name={'NewHome_LatestTransactionCardNumbers1Down'} />
                            </p>
                        </div>
                    </div>
                    <Hidden mdUp>
                        <Divider />
                    </Hidden>
                    <Margin tm={10}></Margin>
                    {/* <div className={classes.item}>
                        <div className={classes.itemImg}>
                            <img src={`${process.env.PUBLIC_URL}/static/images/pc-2.png`} alt="data-ico.png" />
                        </div>
                        <div className={classes.content}>
                            <p style={{ lineHeight: 1 }}>
                                <TR name={'NewHome_LatestTransactionCardNumbers2Up'} />
                            </p>
                            <div className={classes.title}>
                                <h3>+</h3>
                                <CountUp
                                    start={1}
                                    end={inView ? Number(updateNewComersData) : 0}
                                    duration={2}
                                    useEasing={true}
                                />
                                {'  '}
                                <h4>
                                    <TR name={'NewHome_Data'} />
                                </h4>
                            </div>
                            <hr></hr>
                            <p style={{ lineHeight: 1 }}>
                                <TR name={'NewHome_LatestTransactionCardNumbers2Down'} />
                            </p>
                        </div>
                    </div>
                    <Hidden mdUp>
                        <Divider />
                    </Hidden> */}
                </div>
            </div>
        );
    };
});
